import { useAppDispatch, useAppSelector } from "../../redux/store"
import { Link } from "react-router-dom"
import { useState } from "react"
import { loginPhoneStepOne, setError } from "../../redux/slices/auth/authSlice"
import Button from "react-bootstrap/Button"
import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"

import FieldPhone from "./utils/FieldPhone"
import LoginGoogle from "./LoginGoogle"

interface IForm {
  phone: string
}

export const LoginWhatsAppStep1 = () => {
  const { t } = useTranslation()
  const [phone, setPhone] = useState("")
  const { error, status } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()

  const {
    register,
    handleSubmit,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IForm>({})

  const onSubmit = () => {
    dispatch(loginPhoneStepOne({ phone }))
  }

  const clearErrorsField = () => {
    if (error) {
      dispatch(setError(""))
    }

    clearErrors()
  }

  return (
    <form className="login-form " onSubmit={handleSubmit(onSubmit)}>
      <FieldPhone
        errors={errors}
        register={register}
        clearErrorsField={clearErrorsField}
        setPhone={setPhone}
      />

      <div className="login__controls mt-sm-4">
        <Button
          type="submit"
          variant="btn btn  w-100"
          style={{ backgroundColor: "#245192", color: "#ffffff" }}
        >
          {t("buttons.signIn")}
          {/* Sign in */}
        </Button>
      </div>
      <span className="politic-text d-flex  ">
        <Link
          to="https://blog.mazoom.sa/terms"
          className="d-flex"
          style={{ textDecoration: "none" }}
        >
          {" "}
          {/* <span className="w-full" style={{ width: "190px" }}>
            {t("login.politic.text")}
          </span>
          <span style={{ textDecoration: "underline" }}>
            {t(
              "login.politic.termsOfUseAndAcknowledgeThePrivacyPolicyAndCookiePolicy",
            )}
          </span> */}
        </Link>{" "}
        {/* {t("login.politic.textAnd")}
        <Link target="_blank" to="https://blog.mazoom.sa/privacy-policy">
          {t("login.politic.textLinkPrivacyPolicy")}
        </Link> */}
      </span>

      <div className="alternate-login mt-sm-4 d-flex flex-column align-items-center">
        {/* <Link to="/" className="link-login link-login--apple">
          <span className="link-login__text">Apple ID</span>
        </Link> */}

        {/* <h6 className="text-muted d-flex flex-row algin-items-center">
          {" "}
          {t("login.text")}
          <span
            className=""
            style={{
              marginLeft: "10px",
              marginRight: "10px",

              textDecoration: "underline",
            }}
          >
            {" "}
          </span>
        </h6> */}

        <div className="alternate-login w-100">
          {/* <LoginApple /> */}
          {/* <Link to="/login" className="link-login link-login--email w-100">
            <span className="link-login__text">Email</span>
          </Link> */}

          {/* <LoginGoogle /> */}
        </div>
      </div>
    </form>
  )
}

export default LoginWhatsAppStep1
